module.exports = __webpack_public_path__ + "media/images/menu/pictor-da965a850fc0667ea854565be78374c0.jpg";